import $ from 'jquery'
import { gsap } from "gsap";

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

window.Noty = require('noty');

Noty.overrideDefaults({
	theme: 'sunset',
	layout: 'bottomLeft',
	timeout: 5000
})

const $document = $(document)

import { store, cart } from './vue'

$document.ready(() => {

	store.init()
	
	// Load Cart Vue Instance
	cart()

	// kicks off the barba stuff
	require('./barba')

})
